import React from 'react';
import { List, ListItem, spacer8, Type } from '@spotify-internal/encore-web';

import { DocumentLink } from 'lib/sanity/types';
import { useTranslation } from 'providers/translations/TranslationProvider';
import { ArticleLink } from 'components/Links';
import { UbiArticlePage } from 'utils/ubi/pages/useUbiArticle';

export interface RelatedArticlesProps {
  relatedArticles?: DocumentLink[];
  ubi: UbiArticlePage;
}

const RelatedArticles = ({ relatedArticles = [], ubi }: RelatedArticlesProps) => {
  const { t } = useTranslation();

  if (!relatedArticles.length) return null;

  return (
    <>
      <Type as="h2" variant="cello" paddingBottom={spacer8}>
        {t('related_articles')}
      </Type>
      <List>
        {relatedArticles.map((relatedArticle, index) => (
          <ListItem key={relatedArticle.slug}>
            <ArticleLink
              slug={relatedArticle.slug}
              semanticColor="textBrightAccent"
              queryParams={{ ref: 'related' }}
              eventDefinition={{
                category: 'related_articles',
                action: 'click_related_article',
                label: relatedArticle.slug,
              }}
              ubiFactory={ubi.logRelatedArticle(relatedArticle.slug, index)}
            >
              {relatedArticle.title}
            </ArticleLink>
          </ListItem>
        ))}
      </List>
    </>
  );
};

export default RelatedArticles;
